
/**
 * JavaScript React Framework
 */
import React from 'react';

/**
 * React-Bootstrap
 */ 
import { NavDropdown, MenuItem } from 'react-bootstrap';

/**
 * Cascading StyleSheets
 */
 import 'bootstrap/dist/css/bootstrap.min.css';
 import '../../../assets/css/App.css';
 
/**
 * Internal Application Components 
 */
import NavBarMenuItem from '../../common/navbar/NavBarMenuItem.js';
/* import pdf_01 from '../../../assets/pdf/aboutme/BrownTS_Resume.pdf'; */
import pdf_02 from '../../../assets/pdf/aboutme/BrownTS_Biography.pdf';
import pdf_03 from '../../../assets/pdf/aboutme/BrownTS_Personal_Brand.pdf';
/* import zip_01 from '../../../assets/zip/aboutme/BrownTS_Recommendation_Letters.zip'; */

/**
 * Note: Your components tell React what you want to render
 */
class AppNavBarAboutMe extends React.Component {
	render() {
		return (
      <NavDropdown eventKey={this.props.eventKey} title="About Me" id="nav-dropdown">
        <NavBarMenuItem eventKey={this.props.eventKey + ".1"} glyph="cog" href="/index.html#page=Album"> Album</NavBarMenuItem>
        { /* <NavBarMenuItem eventKey={this.props.eventKey + ".2"} glyph="edit" href={pdf_01}> Resume</NavBarMenuItem> */ }
        <NavBarMenuItem eventKey={this.props.eventKey + ".3"} glyph="film" href="http://www.linkedin.com/in/tracysbrown"> LinkedIn</NavBarMenuItem>
        <MenuItem divider />
        <NavBarMenuItem eventKey={this.props.eventKey + ".4"} glyph="star" href={pdf_02}> Biography</NavBarMenuItem>
        <NavBarMenuItem eventKey={this.props.eventKey + ".5"} glyph="edit" href={pdf_03}> Personal Brand</NavBarMenuItem>
        { /* <NavBarMenuItem eventKey={this.props.eventKey + ".6"} glyph="flash" href={zip_01}> Reference Letters</NavBarMenuItem> */ }
      </NavDropdown>
		); // return
	} // render
} // class

/**
 * Expose default class
 */
export default AppNavBarAboutMe;



// WEBPACK FOOTER //
// ./src/cba/appspec/header/Nav_AppNavBar_AboutMe.js